<button 
  [disabled]="_orderWizardService.loading$()"
  class="px-5 py-2 text-sm rounded-md bg-secondary-600 dark:bg-secondary-500 text-white disabled:opacity-40 hover:bg-secondary-500 transition"
  (click)="save()">
  <!--i18n:  Pay -->
  {{ `i18n.app.features.pages.order.wizard.step_06.save-and-pay.button_01` | translate }}
</button>